<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "@/utils/moment";

export default {
  computed: {
    ...mapGetters("addresses", ["addresses"]),
    ...mapState("newPurchase", ["address_id"])
  },

  methods: {
    ...mapActions("newPurchase", ["setAddressId"])
  }
};
</script>

<template>
  <div class="section">
    <div class="section-title">
      SELECIONE O ENDEREÇO
      <hr />
    </div>

    <div class="section-body">
      <div
        v-for="address in addresses"
        :key="address.id"
        class="address"
        :class="{ selected: address_id == address.id }"
        @click="
          setAddressId(address.id);
          $emit('scrollTo', '#tobe');
        "
      >
        <div class="radio-address"></div>

        <div class="title-address">{{ address.name }}</div>

        <div class="mt-5">
          <i>{{ address.cep }}</i>
        </div>

        <div class="text-center">
          {{ address.street }}, {{ address.number }}
          {{ address.complement ? "| " + address.complement + " |" : "" }}
          {{ address.district }} - {{ address.city }}/{{ address.state }}
        </div>

        <div class="buttons-address">
          <div class="m-5">
            <img src="../../../../static/icon-remove.svg" height="15px" />
          </div>

          <div class="m-5">
            <img src="../../../../static/icon-edit.svg" height="15px" />
          </div>
        </div>
      </div>

      <div class="address no-border">
        <div class="icon-plus">+</div>
        <span class="title-address">adicionar endereço</span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.section-body {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.no-border {
  border: none !important;
}

.address {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  width: 180px;
  border: 2px solid #eee;
  border-radius: 4px;
  margin: 10px;
  font-size: 12px;
  cursor: pointer;
  user-select: none;
}

.address.selected {
  border-color: var(--purple);
}

.address.selected .radio-address {
  background: var(--purple);
}

.radio-address {
  width: 15px;
  height: 15px;
  border-radius: 100%;
  border: 2px solid var(--purple);
  margin-bottom: 10px;
}

.title-address {
  font-weight: 600;
  color: var(--purple);
  text-transform: uppercase;
}

.buttons-address {
  display: flex;
  margin-top: 20px;
}

.icon-plus {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 40px;
  background-color: var(--purple);
  border-radius: 100%;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/OrdersAndSubscriptions/Address.vue